import {forwardRef, useEditableControls} from '@chakra-ui/react';

import {EditIconButton} from '../IconButton';

import type {EditableIconButtonProps} from './typings';

export const EditableEditButton = forwardRef<EditableIconButtonProps, 'button'>((props, ref) => {
  const {getEditButtonProps} = useEditableControls();

  return <EditIconButton {...getEditButtonProps(props, ref)} />;
});
